import { Panel as BasePanel } from '../../../../../components/HubPages/components/Panel';
import styled from 'styled-components';
import { media } from '../../../../../helpers/breakpoints';

export const Panel = styled(BasePanel)`
  display: grid;
  grid-template-columns: 1fr;
  grid-column-gap: ${({ theme }) => theme.spacing.L56};
  row-gap: ${({ theme }) => theme.spacing.M16};
  margin-bottom: ${({ theme }) => theme.spacing.M16};

  ${media.medium} {
    grid-template-columns: 1fr 1fr;
  }
`;

export const img = styled.img`
  margin-right: ${({ theme }) => theme.spacing.S8};
`;
